(function (window, document) {
  'use strict';

  var apiName = 't4sScrollOverflow';
  var containerSelector = '[data-scroll-overflow]';

  if (window[apiName]) {
    window[apiName].init(document);
    return;
  }

  function initContainer(container) {
    if (!container || container.dataset.scrollOverflowReady === 'true') return;

    var track = container.querySelector('[data-scroll-overflow-track]');
    var indicator = container.querySelector('[data-scroll-overflow-indicator]');

    if (!track || !indicator) return;

    container.dataset.scrollOverflowReady = 'true';

    var frameId = 0;

    function update() {
      frameId = 0;
      indicator.hidden = track.scrollWidth <= track.clientWidth + 1;
    }

    function requestUpdate() {
      if (frameId) return;
      frameId = window.requestAnimationFrame(update);
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', requestUpdate, { passive: true });
    }

    if ('MutationObserver' in window) {
      var mutationObserver = new MutationObserver(requestUpdate);
      mutationObserver.observe(track, { childList: true, subtree: true });
    }

    update();
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(containerSelector)) {
      initContainer(scope);
    }

    scope.querySelectorAll(containerSelector).forEach(initContainer);
  }

  window[apiName] = { init: init };
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})(window, document);
